/**
 *
 * @param {Map<any, any>} map
 * @param {Map<"name" | "rest", String>} data
 * @param {String} item
 * @returns
 */
const getOptionName = (map, data, item) => {
  let name = data.get("name");

  if (name === "start" && map.get("start")) {
    name = "end";
  }

  return name || item;
}

export default getOptionName;
